
let reopenWidgetEl;
(async () => {
    try {
        //Wait for the shadow host to appear in the page
        const host = await waitForElement('.csm-cookie-consent');

        //Access its shadow root
        const shadow = host.shadowRoot;
        if (!shadow) {
            console.warn('Shadow root is closed or not present — cannot access.');
            return;
        }

        //Wait for the target inside the shadow root
        reopenWidgetEl = await waitForElement('#reopen_widget', shadow);
        reopenWidgetEl.style.setProperty('display', 'none', 'important');
    } catch (e) {
        console.warn(e.message);
    }
})();
 
Array.from(
  document.querySelectorAll(
    ".cookie-consent-manage-btn, a[href$='#manage-cookie-settings']"
  )
).forEach((el) => {
  el.addEventListener("click", openCookieConsentSettings);
});

function openCookieConsentSettings() {
  if (reopenWidgetEl && reopenWidgetEl.parentNode) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          // Check if the node is an element and is the next sibling of #reopen_widget
          if (
            node.nodeType === 1 &&
            reopenWidgetEl.nextElementSibling === node
          ) {
            const allBtns = node.querySelectorAll("button");
            allBtns[allBtns.length - 1].click();
            observer.disconnect(); // Stop observing once found
          }
        });
      });
    });
    // Observe the parent of #reopen_widget for child changes
    observer.observe(reopenWidgetEl.parentNode, { childList: true });
  }

  reopenWidgetEl.click();
}

function waitForElement(selector, root = document, timeout = 15000) {
    return new Promise((resolve, reject) => {
        //Check if it is already loaded
        const existing = root.querySelector(selector);
        if (existing) return resolve(existing);

        const observer = new MutationObserver(() => {
            const el = root.querySelector(selector);
            if (el) {
                observer.disconnect();
                resolve(el);
            }
        });

        observer.observe(root === document ? document.documentElement : root, {
            childList: true,
            subtree: true
        });

        // Give up eventually so it doesn't observe forever
        if (timeout) {
            setTimeout(() => {
                observer.disconnect();
                reject(new Error(`Timed out waiting for ${selector}`));
            }, timeout);
        }
    });
}